export const getNonEmptyString = (
  nullableString: string | null,
  defaultValue: string
) => {
  return nullableString !== null && nullableString !== ""
    ? nullableString
    : defaultValue;
};
